import type { CSSProperties } from "react";
import { colorPalette } from "@command-center-app/utils/colorPalette";

type StatusStyle = {
  backgroundColor: string;
  color: string;
};

const normalizeStatus = (status: string): string =>
  (status ?? "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/_/g, "-");

const greenStyle: StatusStyle = {
  backgroundColor: colorPalette.colorLightMintGreen,
  color: colorPalette.colorVibrantGreen,
};

const redStyle: StatusStyle = {
  backgroundColor: colorPalette.colorSoftPinkRed,
  color: colorPalette.colorPureRed,
};

const yellowStyle: StatusStyle = {
  backgroundColor: colorPalette.colorLightYellow,
  color: colorPalette.colorVibrantYellow,
};

const STATUS_STYLES: Record<string, StatusStyle> = {
  active: greenStyle,
  inactive: redStyle,
  draft: yellowStyle,
  "in-review": yellowStyle,
  archived: redStyle,
  success: greenStyle,
  failed: redStyle,
};

/** Single status badge resolver for all GenericTable status columns. */
export const getStatusBadgeStyle = (status: string): CSSProperties => {
  const key = normalizeStatus(status);
  const colors = (key && STATUS_STYLES[key]) || redStyle;

  return {
    backgroundColor: colors.backgroundColor,
    color: colors.color,
    borderRadius: "4px",
    padding: 8,
    width: "fit-content",
  };
};